<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span>Vista previa de importación</span>
  <button mat-icon-button (click)="closeDialog()" aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content style="padding:0 24px 8px">

  <ng-container *ngIf="ready === false">
    <div class="cf-dlg-loading">
      <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
      <p class="cf-dlg-loading__text">Procesando archivo…</p>
    </div>
  </ng-container>

  <ng-container *ngIf="ready">
    <p style="font-size:12.5px;color:#6b7280;padding:12px 0 4px">
      <span style="color:#16a34a;font-weight:600">&#10004;</span> Asiento visto &nbsp;·&nbsp;
      <span style="color:#16a34a;font-weight:600">&#10004;&#10004;</span> Asiento importado
    </p>

    <div style="overflow-x:auto">
      <table style="width:100%;border-collapse:collapse;font-size:13px">
        <thead>
          <tr style="background:#f3f4f6;color:#374151">
            <th style="padding:8px 10px;text-align:left;border-bottom:1px solid #e5e7eb;font-weight:600"></th>
            <th style="padding:8px 10px;text-align:left;border-bottom:1px solid #e5e7eb;font-weight:600">Fecha</th>
            <th style="padding:8px 10px;text-align:left;border-bottom:1px solid #e5e7eb;font-weight:600">Descripción</th>
            <th style="padding:8px 10px;text-align:left;border-bottom:1px solid #e5e7eb;font-weight:600">Cuenta</th>
            <th style="padding:8px 10px;text-align:left;border-bottom:1px solid #e5e7eb;font-weight:600">Nombre cuenta</th>
            <th style="padding:8px 10px;text-align:right;border-bottom:1px solid #e5e7eb;font-weight:600">Debe</th>
            <th style="padding:8px 10px;text-align:right;border-bottom:1px solid #e5e7eb;font-weight:600">Haber</th>
            <th style="padding:8px 10px;text-align:center;border-bottom:1px solid #e5e7eb;font-weight:600">Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let card of data; trackBy: trackByIndex" style="border-bottom:1px solid #f3f4f6">
            <td style="padding:6px 10px">
              <input (click)="pressCheckbox(card)" type="checkbox">
            </td>
            <td style="padding:6px 10px;white-space:nowrap">{{card.date | date: 'dd/MM/yyyy'}}</td>
            <td style="padding:6px 10px">
              <span [style.background]="card.description === 'Normal' || card.description === 'normal' ? '#16a34a' : '#f59e0b'"
                    style="color:#fff;padding:2px 8px;border-radius:4px;font-size:11.5px;font-weight:600">
                {{card.description}}
              </span>
            </td>
            <td style="padding:6px 10px;font-family:monospace">{{card.accountNumber}}</td>
            <td style="padding:6px 10px">{{card.reference}}</td>
            <td style="padding:6px 10px;text-align:right;font-variant-numeric:tabular-nums">
              <ng-container *ngIf="!card.entryType">{{card.amount}}</ng-container>
              <ng-container *ngIf="card.entryType">0</ng-container>
            </td>
            <td style="padding:6px 10px;text-align:right;font-variant-numeric:tabular-nums">
              <ng-container *ngIf="card.entryType">{{card.amount}}</ng-container>
              <ng-container *ngIf="!card.entryType">0</ng-container>
            </td>
            <td style="padding:6px 10px;text-align:center;color:#16a34a;font-weight:700">
              <ng-container *ngIf="card.closed === true && card.imported === false">&#10004;</ng-container>
              <ng-container *ngIf="card.closed === false && card.imported === true">&#10004;&#10004;</ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end" *ngIf="ready">
  <button mat-stroked-button (click)="closeDialog()">Cancelar</button>
  <button mat-flat-button color="primary" (click)="startImport()">
    <mat-icon>file_upload</mat-icon>
    Importar seleccionados
  </button>
  <button mat-flat-button color="accent" (click)="startImportAll()">
    <mat-icon>done_all</mat-icon>
    Importar todos
  </button>
</mat-dialog-actions>
